var _defs, _rect, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _rect2, _rect3, _rect4, _rect5, _rect6, _polygon9, _rect7, _polygon10, _polygon11, _polygon12, _rect8, _polygon13, _rect9, _polygon14, _rect10, _polygon15, _polygon16, _polygon17, _polygon18, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCp2StickerOnFlatIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b,.e{fill:#efefef;}.b,.c,.d,.e{stroke:#e5e5e5;}.b,.c,.d,.e,.g,.h,.j{stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.b,.c,.f,.g,.h,.i,.j{fill-rule:evenodd;}.c,.d,.j{fill:#fff;}.f,.i{fill:#3c3c46;}.f{opacity:0.15;}.g{fill:#89d9fb;}.g,.h,.j{stroke:#3c3c46;}.h{fill:#ffefe0;}.i{opacity:0.2;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CP-sticker-on-flat-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 140,
    height: 140
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "33.89 5 19.44 19.44 5 5 33.89 5"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "5 5 33.89 33.89 19.44 48.33 5 33.89 5 5"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "5 33.89 33.89 62.78 19.44 77.22 5 62.78 5 33.89"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "5 62.78 33.89 91.67 19.44 106.11 5 91.67 5 62.78"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "5 91.67 33.89 120.56 19.44 135 5 120.56 5 91.67"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "5 120.56 19.44 135 5 135 5 120.56"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "33.89 5 19.44 19.44 33.89 33.89 62.78 5 33.89 5"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "91.67 5 77.22 19.44 62.78 5 91.67 5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 20.68,
    y: 30.9,
    width: 40.86,
    height: 20.43,
    transform: "translate(-17.03 41.11) rotate(-45)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 20.68,
    y: 59.79,
    width: 40.86,
    height: 20.43,
    transform: "translate(-37.46 49.57) rotate(-45)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 59.79,
    y: 35.13,
    width: 20.43,
    height: 40.86,
    transform: "translate(-18.78 65.77) rotate(-45)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 20.68,
    y: 88.68,
    width: 40.86,
    height: 20.43,
    transform: "translate(-57.88 58.03) rotate(-45)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 59.79,
    y: 64.02,
    width: 20.43,
    height: 40.85,
    transform: "translate(-39.21 74.23) rotate(-45)"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "48.33 106.11 19.44 135 48.33 135 62.78 120.56 48.33 106.11"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 59.79,
    y: 92.91,
    width: 20.43,
    height: 40.86,
    transform: "translate(-59.64 82.69) rotate(-45)"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "62.78 120.56 77.22 135 48.33 135 62.78 120.56"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "91.67 5 77.22 19.44 91.67 33.89 120.56 5 91.67 5"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "135 19.44 120.56 5 135 5 135 19.44"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 78.46,
    y: 30.9,
    width: 40.86,
    height: 20.43,
    transform: "translate(-0.11 81.97) rotate(-45)"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "120.56 5 135 19.44 135 48.33 106.11 19.44 120.56 5"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 78.46,
    y: 59.79,
    width: 40.86,
    height: 20.43,
    transform: "translate(-20.53 90.43) rotate(-45)"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "120.56 33.89 135 48.33 135 77.22 106.11 48.33 120.56 33.89"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 78.46,
    y: 88.68,
    width: 40.86,
    height: 20.43,
    transform: "translate(-40.96 98.89) rotate(-45)"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "120.56 62.78 135 77.22 135 106.11 106.11 77.22 120.56 62.78"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "106.11 106.11 77.22 135 106.11 135 120.56 120.56 106.11 106.11"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "120.56 91.67 135 106.11 135 135 106.11 106.11 120.56 91.67"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "120.56 120.56 135 135 106.11 135 120.56 120.56"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M63.35,102.69l-23.63,3.88,1.75,10.66a12,12,0,0,0,23.63-3.88l-1.75-10.66ZM38.21,96.82l23.63-3.88c.91-6.77,2.83-10.24,3.65-20.36C66.59,59,59.2,44.86,49.65,43,39,41,32.44,54.56,32.64,70.93,32.74,79.86,35.24,89.39,38.21,96.82Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M59.74,98.18l-24.29,4,1.8,11a12.31,12.31,0,0,0,24.29-4Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M33.91,92.15l24.29-4c.93-7,2.91-10.53,3.75-20.92,1.12-14-6.47-28.5-16.29-30.39C34.75,34.75,28,48.71,28.18,65.54,28.29,74.71,30.85,84.52,33.91,92.15Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M81.11,82.79l23.63,3.88L103,97.32a12,12,0,0,1-23.63-3.88l1.75-10.66Zm25.13-5.87L82.61,73C81.7,66.27,79.78,62.8,79,52.68,77.87,39.09,85.26,25,94.81,23.12c10.62-2,17.21,11.54,17,27.91C111.72,60,109.22,69.49,106.25,76.92Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M76.82,78.28l24.29,4-1.8,11a12.31,12.31,0,0,1-24.29-4Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M81.14,23.7l.1-.13c2.7-3.49,6-5.92,9.66-6.62,10.92-2.1,17.69,11.86,17.49,28.69,0,1.63-.12,3.29-.28,4.94v.08Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M102.66,72.25l-24.29-4c-.93-7-2.91-10.53-3.75-20.92-.7-8.73,2-17.69,6.53-23.63l27,27A81.85,81.85,0,0,1,102.66,72.25Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M100.69,54.81c-12.92,6.09-23.4.56-23.4-12.36a28.75,28.75,0,0,1,1.12-7.7v0l29.46,15.57-.09.07A37,37,0,0,1,100.69,54.81Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M81.25,23.35l-.13.1c-3.49,2.7-5.92,6-6.62,9.66C72.4,44,86.36,50.8,103.19,50.59c1.63,0,3.29-.12,4.94-.28h.08Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCp2StickerOnFlatIcon);
export default __webpack_public_path__ + "static/media/CP2-sticker-on-flat-icon.79f70794a43500af1dd2e35a475a3ce0.svg";
export { ForwardRef as ReactComponent };